<template>
  <div>
    <iframe
      v-show="isReady"
      id="weworkFrame"
      class="wework-frame"
      :src="url"
      width="185"
      height="205"
      @load="notifyPostMessage"
    />
    <a-spin
      v-if="!isReady"
      class="spin-loading"
    />
  </div>
</template>
<script>

// let timer

window.addEventListener('message', function (event) {
  let origin = event.origin || event.originalEvent.origin
  if (event.data && /work\.weixin\.qq\.com$/i.test(origin)) {
    let nextUrl = event.data
    if (typeof nextUrl !== 'string' || !/^https?/.test(nextUrl)) {
      return
    }

    // if (timer) {
    //   clearInterval(timer)
    // }

    window.location.href = nextUrl
  }
})

// function _notifyPostMessage () {
//   let $frame = document.getElementById('weworkFrame')
//   if (!$frame) {
//     return
//   }

//   if ($frame.contentWindow && $frame.contentWindow.postMessage) {
//     $frame.contentWindow.postMessage('ask_usePostMessage', '*')
//   }
// }

// function _frameOnload () {
//   _notifyPostMessage()

//   // 腾讯云双域名原因，iframe代理后可能跳转多次
//   // timer = setInterval(function () {
//   //   _notifyPostMessage()
//   // }, 1000)
// }

export default {
  'name': 'qwLogin',
  props: {
    url: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isReady: false
    }
  },
  computed: {
  },
  methods: {
    notifyPostMessage () {
      let $frame = document.getElementById('weworkFrame')
      if (!$frame) {
        return
      }

      if ($frame.contentWindow && $frame.contentWindow.postMessage) {
        $frame.contentWindow.postMessage('ask_usePostMessage', '*')
        this.isReady = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.wework-frame {
  width: 185px;
  //height: 185px;
  margin: -8px auto;
  display: block;
}
.spin-loading {
  width: 185px;
  margin: 60px auto 0;
  height: 145px;
  display: block;
}
</style>
